var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEq24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1217_5788)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1217_5788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5V67.5Z",
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 27.675C0.5 19.353 3.16975 12.7748 8.4825 7.87531L8.48252 7.8753C13.8197 2.95359 19.9883 0.5 27 0.5C34.0117 0.5 40.1802 2.95355 45.5173 7.87517C50.826 12.7748 53.5 19.3532 53.5 27.675C53.5 33.1679 51.3183 39.185 46.8794 45.7461C42.4947 52.2272 35.8757 59.2569 27 66.8429C18.1243 59.2569 11.5053 52.2272 7.12058 45.7461C2.68166 39.185 0.5 33.1679 0.5 27.675Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0669 17.745C26.4223 17.745 25.8696 17.513 25.4089 17.0489C24.9482 16.5847 24.7179 16.0268 24.7179 15.3751C24.7179 14.7234 24.9474 14.1646 25.4064 13.6987C25.8654 13.2329 26.4172 13 27.0617 13C27.7063 13 28.2589 13.232 28.7196 13.6961C29.1804 14.1603 29.4107 14.7182 29.4107 15.3699C29.4107 16.0216 29.1812 16.5804 28.7222 17.0462C28.2632 17.5121 27.7114 17.745 27.0669 17.745ZM33.9429 39V32.2075H27.0643C26.4279 32.2075 25.883 31.9784 25.4298 31.5201C24.9766 31.0619 24.75 30.511 24.75 29.8675V21.84C24.75 21.1965 24.975 20.6456 25.425 20.1874C25.875 19.7291 26.4267 19.5 27.08 19.5C27.5552 19.5 27.966 19.5975 28.3125 19.7925C28.6589 19.9875 29.0679 20.3667 29.5393 20.93C30.4393 21.9917 31.425 22.88 32.4964 23.595C33.5679 24.31 34.7357 24.6892 36 24.7325V26.6825C34.9071 26.6825 33.7821 26.4117 32.625 25.87C31.4679 25.3283 30.3536 24.6025 29.2821 23.6925V29.64H33.5571C34.1936 29.64 34.7384 29.8691 35.1916 30.3274C35.6448 30.7856 35.8714 31.3365 35.8714 31.98V39H33.9429ZM24.3 39C22.5214 39 21.0268 38.3879 19.8161 37.1637C18.6054 35.9396 18 34.4283 18 32.63C18 31.1567 18.5304 29.7971 19.5911 28.5512C20.6518 27.3054 22.05 26.585 23.7857 26.39V28.3725C22.6286 28.4808 21.7018 28.9629 21.0054 29.8187C20.3089 30.6746 19.9607 31.6117 19.9607 32.63C19.9607 33.8867 20.3732 34.9375 21.1982 35.7825C22.0232 36.6275 23.0571 37.05 24.3 37.05C25.3071 37.05 26.2393 36.6979 27.0964 35.9937C27.9536 35.2896 28.425 34.3525 28.5107 33.1825H30.4714C30.3 34.9158 29.5929 36.3187 28.35 37.3912C27.1071 38.4637 25.7571 39 24.3 39Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1217_5788",
    x: -4,
    y: 0,
    width: 62,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1217_5788"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1217_5788",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1217_5788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEq24);
export default __webpack_public_path__ + "static/media/pin-eq-24.409d6fa09f759be21adaf85e8b3f9396.svg";
export { ForwardRef as ReactComponent };